import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { error } from 'console';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ContractsService } from 'src/app/services/contracts.service';

@Component({
  selector: 'aw-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements OnInit{

  @ViewChild('fileInput') fileInput: ElementRef;
  selectedFile: File | null = null;
  contractId: number;

  @Output() fileLoaded = new EventEmitter<any>();
  
  constructor(
    private contractService: ContractsService,
    private router: Router,
    private snackbar: MatSnackBar, 
  ) {}

  ngOnInit() {
    this.contractId = parseInt(this.router.url.split("/")[3]);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    } else {
      this.selectedFile = null;
    }
    console.log(this.selectedFile);
  }

  onFileLoad() {
    if (this.selectedFile) {
      this.contractService.getUploadSignedUrl(this.contractId, this.selectedFile.name, this.selectedFile.size).subscribe(response => {
        
        console.log(response)
        let obs = new Observable<any>();
        obs = from(this.selectedFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.contractService.uploadFile(fileBuffer, this.selectedFile.name, this.selectedFile.type, response.data.url, response.data.fields)
          })
        )

        obs.subscribe(response => {
          this.selectedFile = null;
          this.snackbar.open('File Uploaded!', 'Close', {
            duration: 2000
          });
          this.fileLoaded.emit()
        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });


        
      })
    }
  }

  
}
